<div class="samples-details">
  <div class="top-section">
    <button class="btn btn-rg btn-light back-btn" (click)="goBack()">
      <ng-icon name="iconoirNavArrowLeft" size="20"></ng-icon>
      {{ dictionaryService.get('Back') }}
    </button>
  </div>

  <app-tabs [defaultTab]="defaultTab()" (onChangeTab)="onTabChange($event)">
    <app-samples-details-tab [catalogueId]="catalogueId()" [productName]="productName()" />
  </app-tabs>
</div>